<template>
    <div class="folder-check-item">
        <div class="folder-check-item__row">
            <input type="checkbox"
                   :checked="isSelected"
                   @change="$emit('toggle', folder.id)" />
            <i class="material-icons material-icons-round md-18 folder-check-item__icon">folder</i>
            <span>{{ folder.name }}</span>
        </div>
        <div class="folder-check-item__children" v-if="children.length > 0">
            <FolderCheckItem
                v-for="child in children"
                :key="child.id"
                :folder="child"
                :all-folders="allFolders"
                :selected="selected"
                @toggle="$emit('toggle', $event)"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FolderCheckItem',
    props: {
        folder: { type: Object, required: true },
        allFolders: { type: Array, default: () => [] },
        selected: { type: Array, default: () => [] },
    },
    computed: {
        isSelected() {
            return this.selected.includes(this.folder.id);
        },
        children() {
            return this.allFolders.filter(f => f.parent_id === this.folder.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.folder-check-item {
    &__row {
        display: flex;
        align-items: center;
        padding: 4px 0;
        gap: 6px;
        cursor: pointer;
    }
    &__icon {
        color: #868e96;
    }
    &__children {
        padding-left: 24px;
    }
}
</style>
